import { render, staticRenderFns } from "./selectStaffsDiv.vue?vue&type=template&id=324d5444&scoped=true"
import script from "./selectStaffsDiv.vue?vue&type=script&lang=js"
export * from "./selectStaffsDiv.vue?vue&type=script&lang=js"
import style0 from "./selectStaffsDiv.vue?vue&type=style&index=0&id=324d5444&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324d5444",
  null
  
)

export default component.exports